import React from "react";
import { AppBtn } from "../../ui/buttons";
import Modal, { ModalBody, ModalFooter } from "../../ui/modal";
import BaseBtn from "@/components/ui/buttons/base-btn";
import { StoreInterface } from "@/assets/interfaces";

interface Props {
  show: boolean;
  shareAction: () => void;
  toggle: (state: boolean) => void;
  store: StoreInterface;
  itemSlug: string;
}

const StoreInfoModal: React.FC<Props> = ({ show, toggle, shareAction, store }) => {
  const handleShare = () => {
    toggle(false);
    if (typeof shareAction === "function") {
      shareAction(); // Call the shareAction function
    } else {
      console.error("shareAction is not a function", typeof shareAction);
    }
  };

  return (
    <Modal {...{ show, toggle }} title={store?.name} bgClose={false} size="midi">
      <ModalBody noPadding className="px-0 pb-0 pt-0 sm:pt-0">
        <div className="mb-5 sm:mb-3 px-6.25 pb-2.5 bg-grey-modal space-y-2.5">
          <p className="text-black text-1sm md:text-1sm mb-2.5">{store?.description}</p>
          <BaseBtn href={`/${store?.slug}`} color="primary">
            <div className="text-primary-500 flex items-center gap-1">
              Visit store
              {/* prettier-ignore */}
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.53613 11.0359L10.6072 3.96484" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10.6062 11.0359V3.96484H3.53516" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"  strokeLinejoin="round" />
              </svg>
            </div>
          </BaseBtn>
        </div>
        <div className="space-y-5  px-6.25 pb-5 pt-0">
          <div className="w-full mt-0">
            <div className="flex items-center mt-1 py-3 relative overflow-hidden">
              <div className="flex gap-3.75 items-center cursor-pointer" onClick={() => true}>
                <button className="h-8 w-8 sm:h-10 sm:w-10 rounded-full bg-grey-fields-100 flex items-center justify-center text-[#DB3E56]">
                  {/* prettier-ignore */}
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.75 10.05V12.3C12.75 15.3 11.55 16.5 8.55 16.5H5.7C2.7 16.5 1.5 15.3 1.5 12.3V9.45C1.5 6.45 2.7 5.25 5.7 5.25H7.95" stroke="#3E3E3E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12.7502 10.05H10.3502C8.5502 10.05 7.9502 9.45 7.9502 7.65V5.25L12.7502 10.05Z" stroke="#3E3E3E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8.7002 1.5H11.7002" stroke="#3E3E3E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M5.25 3.75C5.25 2.505 6.255 1.5 7.5 1.5H9.465" stroke="#3E3E3E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16.5001 6V10.6425C16.5001 11.805 15.5551 12.75 14.3926 12.75" stroke="#3E3E3E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16.5 6H14.25C12.5625 6 12 5.4375 12 3.75V1.5L16.5 6Z" stroke="#3E3E3E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <span className="font-medium text-sm sm:text-1sm text-black-secondary">Copy Link</span>
              </div>
            </div>
            <div className="flex mt-1 mb-4 border-t border-grey-divider py-4 items-center mt-1 relative overflow-hidden">
              <div className="flex gap-3.75 items-center cursor-pointer" onClick={handleShare}>
                <button className="h-8 w-8 sm:h-10 sm:w-10 rounded-full bg-grey-fields-100 flex items-center justify-center">
                  {/* prettier-ignore */}
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.54977 4.74012L11.9173 2.61762C14.7748 1.66512 16.3273 3.22512 15.3823 6.08262L13.2598 12.4501C11.8348 16.7326 9.49477 16.7326 8.06977 12.4501L7.43977 10.5601L5.54977 9.93012C1.26727 8.50512 1.26727 6.17262 5.54977 4.74012Z" stroke="#3E3E3E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.58203 10.2374L10.267 7.54492" stroke="#3E3E3E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <span className="font-medium text-sm sm:text-1sm text-black-secondary">Share Highlight</span>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default StoreInfoModal;
